import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ControlsChildBaseComponent} from '../base/controls-child-base.component';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../app/app.state';
import {AsideService} from '../../../../core/services/aside.service';
import {UrlService} from '../../../../core/services/url.service';
import {TitleBreadcrumbsChangedAction, TitleChangedAction} from '../../../../core/actions/title.actions';
import {SubnavComponent, SubnavItem} from '../../../components/subnav/subnav.component';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'motn-controls-devices',
  templateUrl: './controls-devices.component.html',
  styleUrls: ['./controls-devices.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SubnavComponent,
    RouterOutlet,
  ],
})
export class ControlsDevicesComponent extends ControlsChildBaseComponent implements OnInit, OnDestroy {
  subnavItems: SubnavItem[];


  constructor(
    protected store: Store<AppState>,
    protected asideService: AsideService,
    protected urlService: UrlService,
  ) {
    super(store, asideService, urlService);

    this.subnavItems = [
      {
        text: 'My Devices',
        href: UrlService.controlsUrls.devicesExisting,
      },
      {
        text: 'Add Devices',
        href: UrlService.controlsUrls.devicesNew,
      },
    ];
  }


  protected onInit(): void {
  }


  protected onDestroy(): void {
  }


  protected updateTitle() {
    this.store.dispatch(new TitleChangedAction(
      '',
      'Devices',
      [{
        text: 'Loading...',
      }],
    ));

    this.store.dispatch(new TitleBreadcrumbsChangedAction(
      [{
        path: UrlService.controlsUrls.dashboard,
        text: 'Controls',
      }, {
        text: 'Devices',
        icon: 'square-d',
      }],
    ));
  }
}
